export const Skills = [
  "Javascript",
  "React",
  "Vue",
  "Typescript",
  "Ionic",
  "Wordpress",
  "C#",
  ".NET",
];
